/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Heeseok Shin (hsshin@rsupport.com)
 *
 * @description
 *
 * @created at Fri Dec 13 2024
 **/

import { Column } from "@/frameworks/designStuff";
import * as S from "./emotion";

export type MiniProfileContentTemplateProps = {
	avatar: {
		render: () => React.ReactNode;
	};
	content?: {
		render: () => React.ReactNode;
	};
	headerIconList?: {
		render: () => React.ReactNode;
	};
	footer?: {
		render: () => React.ReactNode;
	};
};

export default function MiniProfileContentTemplate(props: MiniProfileContentTemplateProps) {
	return (
		<>
			<S.HeaderIcon>{props.headerIconList?.render()}</S.HeaderIcon>
			<S.AvatarColumn>{props.avatar.render()}</S.AvatarColumn>
			<S.ProfileInfoWrapper>
				<Column css={[S.fullWidthStyle, S.infoAreaStyle]} gap={8}>
					{props.content?.render()}
				</Column>
				{props.footer && (
					<>
						<S.Line />
						{props.footer.render()}
					</>
				)}
			</S.ProfileInfoWrapper>
		</>
	);
}
